import { Observable, lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class WebhookService {

  constructor(private http: HttpClient) { }

  changeWebhookDeposit(urlDeposito: string): Promise<any>
  {
    let payloadDeposito = {url: urlDeposito};
    return lastValueFrom(this.http.put(`${environment.apiUrl}/digitopay/webhook/deposit`,payloadDeposito));
  }

  getWebhookDeposit(): Promise<any>
  {
    return lastValueFrom(this.http.get(`${environment.apiUrl}/digitopay/webhook/deposit`));
  }

  changeWebhookWithDraw( urlSaque: string): Promise<any>
  {
    let payloadSaque = {url: urlSaque};
    return lastValueFrom(this.http.put(`${environment.apiUrl}/digitopay/webhook/withdraw`,payloadSaque));
  }

  getWebhookWithDraw(): Promise<any>
  {
    return lastValueFrom(this.http.get(`${environment.apiUrl}/digitopay/webhook/withdraw`));
  }
}
